<template>
  <div>
    <div class="super-wrapper">
        <div class="super-history" @click="goHistory">
          <img class="img" src="../../assets/images/super/history.png" alt="">
          <span class="title">历史记录</span>
        </div>
        <div class="form-group">
            <div class="form-lable">展会名称</div>
            <div class="form-control form-input-wrapper">
                <input v-model="name" class="form-input" type="text" placeholder="请输入展会名称" maxlength="80">
            </div>
        </div>
        <div class="form-group">
          <div class="form-lable">地点</div>
          <div class="form-control form-input-wrapper">
            <input v-model="composeName" class="form-input" type="text" placeholder="请输入展会地点" maxlength="80">
          </div>
        </div>
        <div class="form-group">
          <div class="form-lable">入口</div>
          <div class="form-control form-input-wrapper">
              <input v-model="address" class="form-input" type="text" placeholder="请输入入口地址" maxlength="80">
          </div>
        </div>
        <!-- <div class="form-group">
          <div class="form-lable">企业法人</div>
          <div class="form-control form-input-wrapper">
              <input v-model="enterpriseLegalPerson" class="form-input" type="text" placeholder="请输入企业法人" maxlength="100">
          </div>
        </div>
        <div class="form-group">
          <div class="form-lable">统一社会信用代码</div>
          <div class="form-control form-input-wrapper">
              <input v-model="orgCode" class="form-input" type="text" placeholder="请输入18位统一社会信用代码" maxlength="18">
          </div>
        </div> -->
        <div class="form-group">
          <div class="form-lable">联系人姓名</div>
          <div class="form-control form-input-wrapper">
              <input v-model="contactName" class="form-input" type="text" placeholder="请输入联系人姓名" maxlength="20">
          </div>
        </div>
        <div class="form-group">
          <div class="form-lable">联系人手机号</div>
          <div class="form-control form-input-wrapper">
            <input v-model="contactPhone" class="form-input" type="tel"  placeholder="请输入联系人手机号" maxlength="11">
          </div>
        </div>
        <div class="form-group form-group-button">
          <van-button :loading="loading" type="info" loading-text="提交中..." @click="handleSubmit">提交登记</van-button>
        </div>
    </div>
  </div>
</template>
<script>
import { Toast, Slider, Popup, Button, Uploader } from 'vant'
import { submitInfo } from '@/api/super'
import { areaData, areaIds, streetIds } from '@/utils/config'
import { setStore, removeStore, checkPhone } from '@/utils/index'

export default {
  components: {
    [Slider.name]: Slider,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Uploader.name]: Uploader
  },
  data () {
    return {
      areaData: areaData,
      areaIds: areaIds,
      streetIds: streetIds,
      areaPicker: false,
      streetPicker: false,
      typePicker: false,
      loading: false,
      name: '',
      address: '',
      contactName: '',
      contactPhone: '',
      type: 7, //  1-商超，2-文化公共场所，3-工厂企业，4-金融服务，5-学校，6-农贸市场，7-其它
      typeName: '',
      areaId: '',
      areaName: '',
      streetId: '',
      streetName: '',
      composeName: '',
      typeData: ['商超', '文化公共场所', '工厂企业', '金融服务', '学校', '农贸市场', '其他'],
      orgCode: '',
      enterpriseLegalPerson: '',
      token: ''
    }
  },
  mounted () {
    this.detailId = this.$route.query.detailId
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
      this.token = token
    }
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    goHistory () {
      this.$router.push({ path: '/shistory', query: { id: this.detailId, token: this.token } })
    },
    handleAreaConfirm (value, index) {
      this.composeName = value.join('，')
      this.areaName = value[0]
      this.streetName = value[1]
      this.areaId = this.areaIds[index[0]]
      if (this.areaId) {
        this.streetId = this.streetIds[this.areaId][index[1]]
      }
      this.areaPicker = false
      console.log(this.areaId)
      console.log(this.streetId)
    },
    handleTypeConfirm (value, index) {
      console.log(value)
      console.log(index)
      this.type = index + 1
      this.typeName = value
      this.typePicker = false
    },
    handleSubmit () {
      if (!this.name) {
        Toast({
          message: '请输入展会名称'
        })
        return
      }
      if (this.contactPhone && !checkPhone(this.contactPhone)) {
        Toast({
          message: '请输入正确联系人手机号'
        })
        return
      }
      const data = {
        detailId: this.detailId,
        name: this.name,
        streetName: this.composeName,
        address: this.address,
        contactName: this.contactName,
        contactPhone: this.contactPhone,
        enterpriseLegalPerson: this.enterpriseLegalPerson,
        orgCode: this.orgCode,
        type: this.type
      }
      this.loading = true
      submitInfo(data).then((res) => {
        console.log(res)
        this.loading = false
        if (res.data.code === 200) {
          let id = res.data.result.id
          this.$router.push({ name: 'scode',
            query: {
              detailId: id,
              token: this.token
            }
          })
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .van-button--info{
    background-color: #4f7cf6;
    border-color: #4f7cf6;
    width: 90%;
    border-radius: 40px;
  }
  .super-wrapper {
    min-height: 200vh;
    background: #f7f7f7;
  }
  .super-history {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:10px;
    background: #fff;
    font-size: 16px;
    color: #282828;
    .img {
      width: 23px;
      margin-right: 8px;
    }
    .title {
      flex: 1;
    }
    .arrow {
      width: 12px;
    }
  }

  .form-lable {
    box-sizing: border-box;
    width: 100%;
    padding: 8px 15px;
    background-color: #f7f7f7;
    font-size: 14px;
  }

  .form-control {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 15px;
    background-color: #fff;
    font-size: 14px;
  }
  .form-input-wrapper {
    padding: 3px 15px;
  }
  .form-input {
    box-sizing: border-box;
    width: 98%;
    padding: 9px 3px;
  }
  .form-margin {
    margin-top: 12px;
  }
  .form-group-button {
    display: flex;
    justify-content: center;
    padding: 30px;
    border: 1px solid transparent;
  }
  .form-button {
    width: 92%;
    padding: 8px 0;
    border-radius: 30px;
    background-color: #4f7cf6;
    font-size: 16px;
    color: #fff;
  }
</style>
